// src/api/adminFeatureAdoptionApi.ts
// Adaptador del tablero de ADOPCIÓN DE FUNCIONES (super_admin, 30-ago-2026)
// contra lealify-base routes/admin.js → GET /admin/feature-adoption.
// Una fila por tenant de PAGO con el semáforo de qué funciones automáticas
// (cumpleaños, campañas, avisos de cita, eventos de lealtad) tienen
// SALIDA REAL — el backend mide envíos, nunca el interruptor.
import { baseApi } from './baseClient';

export type AdopcionSemaforo = 'verde' | 'ambar' | 'rojo';
export type EstadoFuncion = 'verde' | 'ambar' | 'apagada' | 'no_aplica';

export interface FuncionAdopcion {
  estado: EstadoFuncion;
  envios?: number;
  ultimo?: string | null;     // YYYY-MM-DD (formateado en SQL)
  canal?: string;             // cumple: 'whatsapp' | 'email' | 'both'
  wa?: number;                // cumple: desglose por canal
  email?: number;
  manual?: number;
  vivas?: number;             // campañas en running/scheduled
}

// Salud del PROGRAMA de lealtad (25-sep-2026): ¿registran visitas y alguien llega a canjear?
// Solo vertical lealtad; el resto llega como { estado: 'no_aplica' }.
export type MotivoPrograma = 'sin_visitas' | 'canjean' | 'sin_premios' | 'opera_a_mano'
  | 'pocos_canjes' | 'listos_sin_canjear' | 'nadie_llega';

export interface ProgramaLealtad {
  estado: 'verde' | 'ambar' | 'rojo' | 'no_aplica';
  motivo?: MotivoPrograma;
  visitas_30d?: number;
  visitas_por_origen?: { kiosco: number; qr: number; manager: number };
  ultima_visita?: string | null;
  canjes?: number;                 // en la ventana (ventana_dias)
  ultimo_canje?: string | null;
  premio_min_pts?: number | null;
  premios_activos?: number;
  listos_para_canjear?: number;    // clientes con saldo ≥ premio más barato HOY
  clientes_con_visita?: number;
  pct_llegaron_premio?: number;    // % de clientes con visita que alguna vez alcanzó el premio
  pct_una_visita?: number;         // % que vino una sola vez
  checkins_30d?: { aprobados: number; pendientes: number; rechazados: number; vencidos: number };
  referidos?: number;
  restas_manuales_30d?: number;    // descuentos manuales INDIVIDUALES (sin operaciones masivas)
  sumas_manuales_30d?: number;     // cargas manuales individuales (negocios que operan a mano)
}

export interface AdopcionTenant {
  tenant_id: number;
  name: string;
  slug: string;
  vertical: string;
  plan: {
    code: string;
    is_trial: boolean;
    reason: string;           // 'pro' | 'trial' | 'legacy_flag' | 'free' | 'expired' | ...
    expires_at: string | null;
    days_left: number | null;
  };
  semaforo: AdopcionSemaforo;
  funciones: {
    cumple: FuncionAdopcion;
    campanas: FuncionAdopcion;
    avisos_cita: FuncionAdopcion;
    eventos_lealtad: FuncionAdopcion;
  };
  programa: ProgramaLealtad;
  prereqs: {
    contactos: number;
    pct_birthdate: number;    // % de contactos activos con fecha de nacimiento
    wa_provisioned: boolean;  // tiene sesión configurada (tenant_settings.whatsapp)
    wa_live: boolean;         // sesión WORKING ahora mismo (wa_session_meta)
    kiosk_pide_fecha: boolean;
  };
}

export interface AdopcionOverview {
  generated_at: string;
  ventana_dias: number;
  tenants: AdopcionTenant[];
}

export const adminFeatureAdoptionApi = {
  overview: () => baseApi.get<AdopcionOverview>('/admin/feature-adoption'),
};

export default adminFeatureAdoptionApi;
